import React from 'react';
import BearriBadge, { BADGE_FOR_MOTION } from './BearriBadge';
import Doodle, { type DoodleName } from './Doodle';
import type { BearriMotionName } from './motionAssets';
import './panelHeading.css';

/** Artwork and copy occupy separate layout slots, including in narrow dialogs. */
export default function PanelHeading({title, eyebrow, description, motion, doodle, className = ''}: {
  title:React.ReactNode; eyebrow?:string; description?:React.ReactNode;
  motion?:BearriMotionName;
  /** a drawing of the object this dialog is about — for dialogs that carry no bear */
  doodle?:DoodleName;
  className?:string;
}) {
  return <div className={`br-panel-heading${motion || doodle ? ' br-panel-heading--illustrated' : ''} ${className}`}>
    {motion ? <BearriBadge name={BADGE_FOR_MOTION[motion]} className="br-panel-heading__badge" />
      : doodle && <Doodle name={doodle} className="br-panel-heading__doodle" />}
    <div className="br-panel-heading__copy">
      {eyebrow && <span className="br-panel-heading__label">{eyebrow}</span>}
      <div className="br-panel-heading__title">{title}</div>
      {description && <div className="br-panel-heading__description">{description}</div>}
    </div>
  </div>;
}
